import { render } from "./DentalBilling.vue?vue&type=template&id=11452830&scoped=true"
import script from "./DentalBilling.vue?vue&type=script&lang=js"
export * from "./DentalBilling.vue?vue&type=script&lang=js"

import "./DentalBilling.vue?vue&type=style&index=0&id=11452830&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11452830"]])

export default __exports__